import { styled } from '@mui/system';
import { TableCell } from '@src/common/components/Table';
import { Tooltip } from '@src/common/components/Tooltip';
import { theme } from '@src/common/styles/Theme';
import { colors } from '@src/common/styles/valueTokens';
import React from 'react';
import { useTranslation } from 'react-i18next';

const StyledTableCell = styled(TableCell)`
  padding: ${theme.spacing['2']} ${theme.spacing['1']};
  text-align: center;
`;

type Props = {
  children: React.ReactNode;
  lastUpdated?: Date | string;
};

export const UpdatableTableCell = ({ children, lastUpdated }: Props) => {
  const { t } = useTranslation();

  const hasUpdate = lastUpdated !== undefined;
  const content = lastUpdated ? (
    <Tooltip title={t('updatedOn') + lastUpdated}>
      <span style={{ display: 'block', width: '100%' }}>{children}</span>
    </Tooltip>
  ) : (
    children
  );

  return (
    <StyledTableCell
      sx={
        hasUpdate ? { border: `2px solid ${colors.tertiary['60']}` } : undefined
      }
    >
      {content}
    </StyledTableCell>
  );
};
